import { insetEnds } from "/src/features/stageEditor/insetEnds.ts";

const NS = "http://www.w3.org/2000/svg";

export function prepareArrowSvg(svg, width, height, markerId, color) {
  svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
  svg.replaceChildren();
  const defs = document.createElementNS(NS, "defs");
  const marker = document.createElementNS(NS, "marker");
  marker.setAttribute("id", markerId);
  marker.setAttribute("orient", "auto");
  marker.setAttribute("markerWidth", "7");
  marker.setAttribute("markerHeight", "7");
  marker.setAttribute("refX", "6");
  marker.setAttribute("refY", "3.5");
  marker.setAttribute("viewBox", "0 0 7 7");
  const path = document.createElementNS(NS, "path");
  path.setAttribute("d", "M0,0 L7,3.5 L0,7 Z");
  path.setAttribute("fill", color);
  marker.appendChild(path);
  defs.appendChild(marker);
  svg.appendChild(defs);
}

export function appendArrow(svg, markerId, x1, y1, x2, y2, pad) {
  const ends = insetEnds(x1, y1, x2, y2, pad);
  const line = document.createElementNS(NS, "line");
  line.setAttribute("x1", String(ends.x1));
  line.setAttribute("y1", String(ends.y1));
  line.setAttribute("x2", String(ends.x2));
  line.setAttribute("y2", String(ends.y2));
  line.setAttribute("marker-end", `url(#${markerId})`);
  svg.appendChild(line);
}
